import { Link } from "react-router-dom";
import { Mail, X } from "lucide-react";
import { useState } from "react";
import assets from "../assets/assets";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="bg-white shadow-lg sticky top-0 z-50 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src={assets.logo01}
              alt="Rice Bazaar Logo"
              className="h-38 w-auto"
            />
          </Link>

          {/* Navigation Links - Desktop */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className="text-[#305669] hover:text-[#1785A] transition-colors duration-200 font-medium"
            >
              Home
            </Link>
            <Link
              to="/shop"
              className="text-[#305669] hover:text-[#1785A] transition-colors duration-200 font-medium"
            >
              Shop
            </Link>
            <Link
              to="/contact"
              className="text-[#305669] hover:text-[#1785A] transition-colors duration-200 font-medium"
            >
              Contact
            </Link>
          </div>

          {/* Contact Info - Gmail Only */}
          <div className="hidden lg:flex items-center text-[#305669]">
            <a
              href="mailto:anmolstore668@gmail.com"
              className="flex items-center space-x-2 hover:text-[#1785A] transition-colors duration-200"
            >
              <Mail className="h-4 w-4" />
              <span className="text-sm">info@grainly.in.net</span>
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="text-[#305669] hover:text-[#1785A] p-2"
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden pb-4 border-t border-gray-200 mt-2">
            <div className="flex flex-col space-y-3 pt-4">
              <Link
                to="/"
                onClick={closeMobileMenu}
                className="text-[#305669] hover:text-[#1785A] hover:bg-[#B7E5CD]/20 transition-colors duration-200 font-medium px-4 py-2 rounded"
              >
                Home
              </Link>
              <Link
                to="/shop"
                onClick={closeMobileMenu}
                className="text-[#305669] hover:text-[#1785A] hover:bg-[#B7E5CD]/20 transition-colors duration-200 font-medium px-4 py-2 rounded"
              >
                Shop
              </Link>
              <Link
                to="/contact"
                onClick={closeMobileMenu}
                className="text-[#305669] hover:text-[#1785A] hover:bg-[#B7E5CD]/20 transition-colors duration-200 font-medium px-4 py-2 rounded"
              >
                Contact
              </Link>
              <div className="px-4 pt-2 border-t border-gray-200 mt-2">
                <a
                  href="mailto:info@grainly.in.net"
                  className="flex items-center space-x-2 text-[#305669] hover:text-[#1785A] transition-colors duration-200"
                >
                  <Mail className="h-4 w-4" />
                  <span className="text-sm">info@grainly.in.net</span>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
